import React from 'react';
import { useTranslation } from 'react-i18next';
import { ReactComponent as ArrowLeftIcon } from 'assets/icons/arrow-left.svg';
import { ReactComponent as CloseIcon } from 'assets/icons/close.svg';

import type IAICardPanelHeader from '../interfaces/IAICardPanelHeader';

import styles from '../sass/AICardPanel.module.scss';

function AICardPanelHeader({
  onClose, onBack, titleKey, title,
}: IAICardPanelHeader): React.JSX.Element {
  const { t } = useTranslation();

  return (
    <div className={styles.header}>
      <div className={styles.headerTopRow}>
        <button
          type="button"
          onClick={onBack || onClose}
          className={styles.iconButton}
          aria-label={t('common.back')}
          data-i18n-key="common.back"
        >
          <ArrowLeftIcon />
        </button>
        <span className={styles.headerTitle}>
          {title || t(titleKey || 'valueChainMap.aiPanelTitle')}
        </span>
        <button
          type="button"
          onClick={onClose}
          className={styles.iconButton}
          aria-label={t('common.close')}
          data-i18n-key="common.close"
        >
          <CloseIcon />
        </button>
      </div>
    </div>
  );
}

export default AICardPanelHeader;
